import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "item-content-changed__header" }
const _hoisted_2 = { class: "heading-level-3" }
const _hoisted_3 = { class: "body-text-large-400" }
const _hoisted_4 = { class: "item-content-changed__content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "item-content-changed__label" }, "Before:", -1)
const _hoisted_6 = { class: "item-content-changed__description" }
const _hoisted_7 = { class: "item-content-changed__content" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "item-content-changed__label" }, "After:", -1)
const _hoisted_9 = { class: "item-content-changed__description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommentOwner = _resolveComponent("CommentOwner")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_ControlButtons = _resolveComponent("ControlButtons")!
  const _component_CustomModal = _resolveComponent("CustomModal")!

  return (_openBlock(), _createBlock(_component_CustomModal, {
    id: `item-description-changed-${_ctx.comment.id}`,
    modalClass: "custom-modal_item-description",
    width: "75%"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_CommentOwner, {
          user: _ctx.comment.owner,
          userNameWeight: "400"
        }, {
          username: _withCtx(({ userName }) => [
            _createTextVNode(_toDisplayString(userName) + " ", 1),
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.comment.subtitleLabel), 1)
          ]),
          _: 1
        }, 8, ["user"]),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.comment.timeAndDateReversed), 1)
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("span", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Editor, {
            id: "description",
            type: "read",
            value: _ctx.beforeDescription,
            extensions: _ctx.extensions
          }, null, 8, ["value", "extensions"])
        ])
      ]),
      _createElementVNode("span", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Editor, {
            id: "description",
            type: "read",
            value: _ctx.afterDescription,
            isAttachmentResizable: false,
            extensions: _ctx.extensions
          }, null, 8, ["value", "extensions"])
        ])
      ])
    ]),
    footer: _withCtx(({ hide }) => [
      _createVNode(_component_ControlButtons, {
        hideCancel: true,
        onSave: hide
      }, {
        save: _withCtx(() => [
          _createTextVNode(" Ok ")
        ]),
        _: 2
      }, 1032, ["onSave"])
    ]),
    _: 1
  }, 8, ["id"]))
}